import React from "react";
import thinking from "../Image/thinking.png";
import thinking1 from "../Image/thinking1.png";
import { Wave } from 'react-animated-text';
const Intermetent = () => {
  return (
    <center>
      <div className="">
        <div className="flex items-center justify-center  ">
          <img src={thinking} alt="" className=" hidden w-[300px] md:w-[400px] mt-[104px] dark:block" />
          <img src={thinking1} alt="" className="w-[300px] h-[300px] md:w-[400px] mt-[104px] dark:hidden" />
        </div>

        <div className="flex  md:flex-row items-center justify-center ">
          <p
            className=" dark:text-white text-[20px] md:text-[44px]  " 
          >
            Deepesh is thinking
          </p>
          <p
            className="dark:text-white pl-2 pb-2 md:pb-8 text-[42px] md:text-[104px] drop-shadow-[4px_4px_#17A6DB] dark:drop-shadow-[4px_4px_#30dada]"
          
          >
           <Wave
              text="...."
              effect="stretch"
              effectChange="2"
            />
          
          </p>
        </div>
      </div>
    </center>
  );
};

export default Intermetent;
